//项目信息处理js

/**
 * 处理项目列表操作
 * @param {*} params 项目基本信息
 * 
 */
// markerFrom: [ 
//   { label: '物探点号', type: 'input', value: 'intuitionPoint' },
//   { label: '特征点', type: 'select', value: 'featurePoint', list: ['三通', '弯头', '变径'] },
//   { label: '竣工时间', type: 'time', value: 'time' },
// ] 最后形成模型
export function sortBasicInfoList (params) {
  //创建模型列表
  let fromList = [];
  params.forEach(element => {
    //创建对象
    let obj = {}
    //如果attributeValue为空则是input类型 key为是否和其他值合并
    if (element.attributeValue == null) {
      obj = { label: element.attributeName, type: 'input', value: element.attributeName, key: element.mutualExclusivity }
    } else {
      //如果没有多list列表则是普通下拉列表
      if (element.attributeValueTwo == null) {
        let list = [];
        //处理下拉项目列表
        element.attributeValue.forEach(valeu => {
          list.push(valeu.elementName);
        })
        obj = { label: element.attributeName, type: 'select', value: element.attributeName, key: element.mutualExclusivity, list, inputData: { flag: false } }
      } else {

        let options = [];
        let list = [];

        if (element.attributeValueTwo.attributeValueList.length == 0) {
          //处理下拉项目列表
          element.attributeValue.forEach(valeu => {
            list.push(valeu.elementName);
          })
          obj = { label: element.attributeName, type: 'select', value: element.attributeName, key: element.mutualExclusivity, list, inputData: { flag: false } }
        } else {
          //处理下拉项目列表
          element.attributeValue.forEach(valeu => {
            list.push({
              value: valeu.elementName,
              label: valeu.elementName
            });
          })
          //原生列表添加
          options.push({
            value: element.attributeName,
            label: element.attributeName,
            children: list
          })
          //处理多选列表
          //创建list集合
          let list2 = [];
          //循环列表值添加进list
          element.attributeValueTwo.attributeValueList.forEach(valeu2 => {
            list2.push({
              value: valeu2.elementName,
              label: valeu2.elementName
            });
          })
          //原生列表添加
          options.push({
            value: element.attributeValueTwo.key,
            label: element.attributeValueTwo.key,
            children: list2
          })
          obj = { label: element.attributeName, type: 'options', value: element.attributeName, key: element.mutualExclusivity, options }
        }
      }
      if (element.inputData != null) {
        obj.inputData = {
          flag: false,
          data: element.inputData
        }
      } else {
        obj.inputData = {
          flag: false,
        }
      }
    }
    fromList.push(obj);
  });
  // console.log(fromList);

  return fromList;
}


/**
 * 生成树型菜单
 * @param {*} params 
 */
export function sortBasicInfoTree (params, list) {
  const treeData = []
  // 筛选函数
  const filteredData = params.filter(item => list.includes(item.attributeName));
  console.log(filteredData);
  filteredData.forEach(item => {
    let parent = {
      title: item.attributeName,
      key: item.attributeName,
      disabled: true,
      children: []
    }
    item.attributeValue.forEach(value => {
      let children = {
        title: value.elementName,
        key: value.elementName,
        show: true
      }
      parent.children.push(children);
    })
    treeData.push(parent);
  })
  return treeData;

}
